import { FilterChipContainer, FilterForm, useFiltersReturn } from "@/components/filters";
import { Dialog, Drawer, ModalHeader } from "@/components/modal";

interface HeaderFiltersProps {
    filterData: useFiltersReturn
    dialog?: boolean
}

export default function HeaderFilters({
    filterData,
    dialog = false
}: HeaderFiltersProps) {

    const renderModal = () => {
        if (dialog) {
            return <Dialog code="filterModal">
                <ModalHeader>Filtros</ModalHeader>
                <FilterForm filterData={filterData} />
            </Dialog>
        } else {
            return <Drawer code="filterModal">
                <ModalHeader>Filtros</ModalHeader>
                <FilterForm filterData={filterData} />
            </Drawer>
        }
    }

    return <>
        <FilterChipContainer filterData={filterData} />
        {renderModal()}
    </>
}